<div [class]="'w-fit-content special-categories-card rounded-4 border-0 shadow-sm bg-white bg-opacity-50 '+item().borderClass"
    (click)="onCategoryClicked()" role="button">
    <div class="d-flex align-items-center gap-3">
        <img [src]="item().specialIcon || 'assets/images/product-placeholder.webp'" class="img-fluid rounded-4 object-fit-cover" alt="...">
        <p class="special-categories-card__title m-0 h6-bold head-font text-black">{{item().name}}</p>
    </div>
</div>